import { LICENSE_MODULES, ROLES } from '../../../../../constants';

import Users from '../../v2/components/administration/users/users';
import UserDetails from '../../v2/components/administration/users/user-details';
import Settings from '../../v2/components/administration/settings';
import Details from '../../v2/components/CRUD/details-page';
import Lists from '../../v2/components/reports/lists';
import DynamicData from '../../v2/components/reports/dynamic-data';
import DynamicDataDetails from '../../v2/components/reports/dynamic-data/dynamic-data-details';
import DynamicDataContent from '../../v2/components/reports/dynamic-data/dynamic-data-content';
import Company from '../../v2/components/one/reference-data/company';
import Content from '../../v2/components/reports/content';
import Stickers from '../../v2/components/reports/stickers';
import ListDetails from '../../v2/components/reports/lists/list-details';
import ContentDetails from '../../v2/components/reports/content/content-details';
import Dashboard from '../../components/dashboard/dashboard';
import Teams from '../../v2/components/reports/teams/teams';
import TeamDetails from '../../v2/components/reports/teams/team-details';

export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'dashboard',
      requiresAuth: true,
      modules: [
        LICENSE_MODULES.AVG,
        LICENSE_MODULES.IS_REPORTS_PART,
        LICENSE_MODULES.ONE,
        LICENSE_MODULES.RPTRADE,
        LICENSE_MODULES.TICKETS,
        LICENSE_MODULES.GMVA,
      ],
      roles: '*',
    },
  },
  {
    path: '/teams',
    name: 'teams',
    component: Teams,
    meta: {
      title: 'teams',
      requiresAuth: true,
      modules: [LICENSE_MODULES.AVG, LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE, LICENSE_MODULES.TICKETS, LICENSE_MODULES.GMVA],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/team-details/:id',
    name: 'team-details',
    component: TeamDetails,
    meta: {
      title: 'Team Details',
      requiresAuth: true,
      modules: [LICENSE_MODULES.AVG, LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE, LICENSE_MODULES.TICKETS, LICENSE_MODULES.GMVA,],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      title: 'users',
      requiresAuth: true,
      modules: [LICENSE_MODULES.AVG, LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE, LICENSE_MODULES.TICKETS, LICENSE_MODULES.GMVA],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/user-details/:id',
    name: 'user-details',
    component: UserDetails,
    meta: {
      title: 'User Details',
      requiresAuth: true,
      modules: [LICENSE_MODULES.AVG, LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE, LICENSE_MODULES.TICKETS, LICENSE_MODULES.GMVA],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/details',
    name: 'details',
    component: Details,
    meta: {
      title: 'details',
      requiresAuth: true,
      modules: [LICENSE_MODULES.AVG, LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE, LICENSE_MODULES.GMVA],
      roles: '*',
    },
  },
  {
    path: '/system',
    name: 'settings',
    component: Settings,
    meta: {
      title: 'settings',
      requiresAuth: true,
      roles: [ROLES.SUPERADMIN],
    },
  },
  {
    path: '/lists',
    name: 'lists',
    component: Lists,
    meta: {
      title: 'Lists',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
    },
  },
  {
    path: '/company',
    name: 'company',
    component: Company,
    meta: {
      title: 'Company',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
    },
  },
  {
    path: '/create-list',
    name: 'create-list',
    component: ListDetails,
    meta: {
      title: 'Create List',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
      isGoBackBtn: true,
    },
  },
  {
    path: '/list-details/:id',
    name: 'list-details',
    component: ListDetails,
    meta: {
      title: 'List Details',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
    },
  },
  {
    path: '/content',
    name: 'content',
    component: Content,
    meta: {
      title: 'Content',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
    },
  },
  {
    path: '/create-content',
    name: 'create-content',
    component: ContentDetails,
    meta: {
      title: 'Create Content',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
      isGoBackBtn: true,
    },
  },
  {
    path: '/content-details/:id',
    name: 'content-details',
    component: ContentDetails,
    meta: {
      title: 'Content Details',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
    },
  },
  // {
  //   path: '/stickers',
  //   name: 'stickers',
  //   component: Stickers,
  //   meta: {
  //     title: 'Sticker list',
  //     requiresAuth: true,
  //     roles: '*',
  //     modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
  //   },
  // },
  {
    path: '/dynamic-data',
    name: 'dynamic-data',
    component: DynamicData,
    meta: {
      title: 'Dynamic data',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
    },
  },
  {
    path: '/create-dynamic-data-structure',
    name: 'create-dynamic-data-structure',
    component: DynamicDataDetails,
    meta: {
      title: 'Create dynamic data structure',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
      isGoBackBtn: true,
    },
  },
  {
    path: '/dynamic-data/:id',
    name: 'dynamic-data-details',
    component: DynamicDataDetails,
    meta: {
      title: 'Dynamic data details',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
      isGoBackBtn: true,
    },
  },
  {
    path: '/dynamic-data-content/:id',
    name: 'dynamic-data-content',
    component: DynamicDataContent,
    meta: {
      title: 'Dynamic data content',
      requiresAuth: true,
      roles: '*',
      modules: [LICENSE_MODULES.IS_REPORTS_PART, LICENSE_MODULES.ONE],
      isGoBackBtn: true,
    },
  },
];
